import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Form } from 'react-bootstrap'; 
import { ConfirmDialog } from '../../common/Utilities';
import { togglePrompt, 
          toggleShowAlert,
          ERROR_ALERT } from '../../store/actions/commonActions';
import { fetchApprovals, approveTimesheet, rejectTimesheet, approveAllTimesheets } from '../../store/actions/timesheet/approvalsActions';
import { addRemarks } from '../../store/actions/timesheet/timesheetActions';

class TimesheetConfirmations extends Component {


  componentDidMount() {
    this.props.fetchApprovals();  
  }

  uncheckAllBoxen = () => {
    //uncheck all boxes
    document.querySelectorAll('input[type=checkbox]').forEach( el => el.checked = false );
  }

  render() {
    const remarksId = "remarks";

    let modalTitle = '';
    let modalBody = '';
    let onHideFunction = {}
    let onClickCancel = {}
    let onClickConfirm = {}
    let specialForm = '';

    switch (this.props.confirmAction) {
      case 'SUBMIT_TIMESHEET':
        modalTitle = 'Delete Project';
        modalBody = 'Are you sure you want to submit this timesheet?';
        
        onClickConfirm = () => {
          this.props.trashProject(this.project.id);
          this.props.togglePrompt(false);
        }
        break;
      case 'APPROVE_TIMESHEET':
        modalTitle = 'Approve Timesheet';
        if (this.props.timesheetid) {
          modalTitle += ": " + this.props.requestid;
        }
        modalBody = 'Are you sure you want to approve this timesheet?';

        onClickConfirm = () => {

          this.uncheckAllBoxen();
          
          const approvals = this.props.approvals.approvals;
          const hasMissingHours = approvals.filter(approval => +approval.timesheet_id === +this.props.timesheetid).some(approval => approval.total_missing_hours);

          if (!hasMissingHours) {
            this.props.approveTimesheet(this.props.timesheetid, () => {
            this.props.togglePrompt(false);       
            this.props.fetchApprovals();     
            if (this.props.inDashboard) {
              this.props.history.push('/dashboard');
              document.querySelector("tr#timesheetid" + this.props.timesheetid).remove();
            } else {
              this.props.history.push('/approvals');
            }
          });
          } else {
            this.props.togglePrompt(false);
            this.props.toggleShowAlert(true, ERROR_ALERT, 'Cannot approve timesheets with missing hours.');
          }
        }
        break;
      case 'APPROVE_SELECTED_TIMESHEETS':
        modalTitle = 'Approve Timesheets';
        if (this.props.timesheetids && this.props.timesheetids.length > 0) {
          modalTitle += ": " + this.props.requestids.join(", ");

          modalBody = 'Are you sure you want to approve these timesheets?';

          onClickConfirm = () => {

            this.uncheckAllBoxen();

            this.props.approveAllTimesheets(this.props.timesheetids, () => {
              this.props.togglePrompt(false);
              this.props.fetchApprovals();
              if (this.props.inDashboard) {
                this.props.history.push('/dashboard');
                
                
                this.props.timesheetids.forEach(timesheetid => {
                  document.querySelector("tr#timesheetid" + timesheetid).remove();
                });
              } else {
                this.props.history.push('/approvals');
              }
            });
          }
        }
       
        break;
      case 'REJECT_TIMESHEET':
        modalTitle = 'Reject Timesheet';
        if (this.props.timesheetid) {
          modalTitle += ": " + this.props.requestid;
        }
        modalBody = 'Are you sure you want to reject this timesheet?';

        onClickConfirm = () => {

          this.uncheckAllBoxen();

          this.props.rejectTimesheet(this.props.timesheetid, () => {
            this.props.togglePrompt(false);
            this.props.fetchApprovals();
            if (this.props.inDashboard) {
              this.props.history.push('/dashboard');
              document.querySelector("tr#timesheetid" + this.props.timesheetid).remove();
            } else {
              this.props.history.push('/approvals');
            }
          });
          
        }

        specialForm = <>
          <Row className="mt-3">
            <Col>
              <Form>
                <Form.Group>
                  <Form.Label>Remarks: <i style={{fontSize: "0.75em"}}>(Atleast 10 characters)</i></Form.Label>
                  <Form.Control 
                    as="textarea" 
                    rows="3" 
                    id={remarksId} 
                    onChange={this.props.addRemarks}/>
                </Form.Group>
              </Form>
            </Col>
          </Row>
        </>
        break;

      case 'REJECT_SELECTED_TIMESHEETS':
        modalTitle = 'Reject Timesheets';
        if (this.props.timesheetids) {
          modalTitle += ": " + this.props.timesheetids.join(", ");
        }
        modalBody = 'Are you sure you want to reject these timesheets?';

        onClickConfirm = () => {

          this.uncheckAllBoxen();
          
          this.props.rejectAllTimesheets(this.props.timesheetids, () => {
            this.props.togglePrompt(false);
            this.props.fetchApprovals();
            if (this.props.inDashboard) {
              this.props.history.push('/dashboard');
            } else {
              this.props.history.push('/approvals');
            }
          });
          
        }

        specialForm = <>
          <Row className="mt-3">
            <Col>
              <Form>
                <Form.Group>
                  <Form.Label>Remarks for each Timesheet:</Form.Label>
                  <Form.Control 
                    as="textarea" 
                    rows="3" 
                    id={remarksId} 
                    onChange={this.props.addRemarks}/>
                </Form.Group>
              </Form>
            </Col>
          </Row>
        </>
        break;
        
      default: 
        break;
    }

    onHideFunction = () => {
      this.props.togglePrompt(false);
    }

    onClickCancel = () => {
      this.props.togglePrompt(false);
    }

    return (
      <ConfirmDialog 
          show={this.props.common.togglePrompt} 
          modalTitle={modalTitle} 
          modalBody={modalBody} 
          onHideFunction={onHideFunction}
          onClickCancel={onClickCancel}
          onClickConfirm={onClickConfirm} 
          specialForm={specialForm}
          remarksId={remarksId}
      />
    ) 
  }
}

const mapStateToProps = (state) => ({
  timesheets: state.timesheets,
  common: state.common,
  approvals: state.approvals
})

const mapDispatchToProps = (dispatch) => {
  return {
    togglePrompt: (...args) => dispatch(togglePrompt(...args)),
    approveTimesheet: (...args) => dispatch(approveTimesheet(...args)), 
    rejectTimesheet: (...args) => dispatch(rejectTimesheet(...args)),
    approveAllTimesheets: (...args) => dispatch(approveAllTimesheets(...args)),
    addRemarks: (...args) => dispatch(addRemarks(...args)),
    fetchApprovals: (...args) => dispatch(fetchApprovals(...args)),
    toggleShowAlert: (...args) => dispatch(toggleShowAlert(...args))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TimesheetConfirmations))
